import type { TFunction } from 'i18next';

import type { AgeRangeFilter, FilterState, WhenPreset } from './filterState';

export const WHEN_PRESETS: readonly WhenPreset[] = [
  'anytime',
  'today',
  'weekend',
  'next7days',
  'thisMonth',
  'custom',
];

/** Label for a time preset (activities namespace). Custom shows its dates once both are set. */
export function whenPresetLabel(
  f: Pick<FilterState, 'whenPreset' | 'dateFrom' | 'dateTo'>,
  t: TFunction
): string {
  switch (f.whenPreset) {
    case 'today':
      return t('when.today');
    case 'weekend':
      return t('when.thisWeekend');
    case 'next7days':
      return t('when.next7days');
    case 'thisMonth':
      return t('when.thisMonth');
    case 'custom':
      return f.dateFrom && f.dateTo
        ? t('when.dateRange', { from: f.dateFrom, to: f.dateTo })
        : t('when.customRange');
    default:
      return t('when.anytime');
  }
}

/** "3-5 岁" / "8 岁以上" for a stage range from a homepage link. */
export function ageRangeLabel(range: AgeRangeFilter, t: TFunction): string {
  return range.hi === undefined
    ? t('filters.ageFrom', { lo: range.lo })
    : t('filters.ageRange', { lo: range.lo, hi: range.hi });
}
